import axios from 'axios';
import {
  GET_ADDON_PACKAGES_REQUEST,
  GET_ADDON_PACKAGES_SUCCESS,
  GET_ADDON_PACKAGES_FAIL,
  CREATE_ADDON_PACKAGE_REQUEST,
  CREATE_ADDON_PACKAGE_SUCCESS,
  CREATE_ADDON_PACKAGE_FAIL,
  UPDATE_ADDON_PACKAGE_REQUEST,
  UPDATE_ADDON_PACKAGE_SUCCESS,
  UPDATE_ADDON_PACKAGE_FAIL,
  DELETE_ADDON_PACKAGE_REQUEST,
  DELETE_ADDON_PACKAGE_SUCCESS,
  DELETE_ADDON_PACKAGE_FAIL,
  baseURL
} from "./types";

// Utility: Get token from localStorage
const getAuthToken = () => {
  const loginData = JSON.parse(localStorage.getItem('loginData') || '{}');
  const directToken = localStorage.getItem('token');
  return loginData.token || directToken || '';
};

// Get auth headers configuration
const getAuthHeaders = () => {
  const token = getAuthToken();
  return {
    headers: {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${token}`
    }
  };
};

// Get All Addon Packages - Simple POST version
export const getAllAddonPackages = () => async (dispatch) => {
  try {
    dispatch({ type: GET_ADDON_PACKAGES_REQUEST });

    const config = getAuthHeaders();

    const { data } = await axios.post(
      `${baseURL}/api/appointmentAdminAddonPackages/getall`,
      {}, // Empty body
      config
    );

    console.log('API Response:', data);

    // Direct extraction based on your API structure {success: 1, data: [...]}
    const packagesArray = data.success === 1 ? data.data : [];

    dispatch({
      type: GET_ADDON_PACKAGES_SUCCESS,
      payload: packagesArray,
    });
    return Promise.resolve(packagesArray);

  } catch (error) {
    console.error('Error fetching addon packages:', error);
    dispatch({
      type: GET_ADDON_PACKAGES_FAIL,
      payload: error.response?.data?.message || error.message,
    });
    return Promise.reject(error);
  }
};

// Create Addon Package
export const createAddonPackage = (packageData) => async (dispatch) => {
  try {
    dispatch({ type: CREATE_ADDON_PACKAGE_REQUEST });

    const config = getAuthHeaders();

    const { data } = await axios.post(
      `${baseURL}/api/appointmentAdminAddonPackages/create`,
      packageData,
      config
    );

    dispatch({
      type: CREATE_ADDON_PACKAGE_SUCCESS,
      payload: data.newAddonPackage || data.data || data,
    });
    return Promise.resolve(data);

  } catch (error) {
    dispatch({
      type: CREATE_ADDON_PACKAGE_FAIL,
      payload: error.response?.data?.message || error.message,
    });
    return Promise.reject(error);
  }
};

// Update Addon Package - FIXED ENDPOINT
export const updateAddonPackage = (packageData) => async (dispatch) => {
  try {
    dispatch({ type: UPDATE_ADDON_PACKAGE_REQUEST });

    const config = getAuthHeaders();

    // Fixed endpoint - changed from 'delete' to 'update'
    const { data } = await axios.patch(
      `${baseURL}/api/appointmentAdminAddonPackages/update`,
      packageData,
      config
    );

    dispatch({
      type: UPDATE_ADDON_PACKAGE_SUCCESS,
      payload: data.updatedAddonPackage || data.data || data,
    });
    return Promise.resolve(data);

  } catch (error) {
    dispatch({
      type: UPDATE_ADDON_PACKAGE_FAIL,
      payload: error.response?.data?.message || error.message,
    });
    return Promise.reject(error);
  }
};

// Delete Addon Package: DELETE /api/appointmentAdminAddonPackages/delete
export const deleteAddonPackage = (id) => async (dispatch) => {
  try {
    dispatch({ type: DELETE_ADDON_PACKAGE_REQUEST });

    const config = getAuthHeaders();

    const { data } = await axios.delete(
      `${baseURL}/api/appointmentAdminAddonPackages/delete`,
      {
        ...config,
        data: { id } // Send ID in request body for DELETE
      }
    );

    dispatch({
      type: DELETE_ADDON_PACKAGE_SUCCESS,
      payload: id, // Return the deleted ID to remove from state
    });
    return Promise.resolve(data);

  } catch (error) {
    dispatch({
      type: DELETE_ADDON_PACKAGE_FAIL,
      payload: error.response?.data?.message || error.message,
    });
    return Promise.reject(error);
  }
};